"use strict";
AGA.DynamicQuery = (function () {

    var saveTimeout = null;
    var isCustomQuery = false;
    var isReadOnly = false;

    var clearSaveTimeout = function () {
        if (saveTimeout)
            clearTimeout(saveTimeout);
        saveTimeout = null;
    };

    var getModalConfiguration = function (configuration) {
        var defaults = {
            id: 'DynamicQueryModal',
            url: '',
            size: "large",
            displayFooter: false,
            displayTitle: false,
            // ocupar 90% da altura, menos a altura do footer do modal
            height: parseInt($(window).height() * 0.9) - 70
        };

        var result = $.extend(defaults, configuration);
        return result;
    };

    var getCurrentQueryId = function () {
        var value = AGA.Lookup.getValue("DynamicQuerySelectorMain");
        return value;
    };

    var updateFilters = function (queryId) {
        if (isCustomQuery) {
            AGA.DynamicQuery.Custom.updateCustomFilters();
        } else {
            AGA.Helper.blockElement("#FiltrosBody", "Carregando filtros...");
            var url = AGA.Ajax.getUrlPath("DynamicQuery/GetFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());

            // Update filtros
            $("#FiltrosPlaceholder").load(url, function () {
                AGA.Helper.unblockElement("#FiltrosBody");
                AGA.JavascriptButton.enable("#ModificarFiltrosButton");
                AGA.JavascriptButton.enable("#LimparFiltrosButton");
                $(".btn-generation").each(function (index, item) {
                    AGA.JavascriptButton.enable(item);
                });
            });
        }
    };

    var updateColumns = function (queryId) {
        if (isCustomQuery) {
            AGA.DynamicQuery.Custom.updateCustomColumns(queryId);
        } else {
            AGA.Helper.blockElement("#ColumnsBody", "Carregando colunas...");
            var url = AGA.Ajax.getUrlPath("DynamicQuery/GetColumns?queryId=" + String(queryId) + "&_=" + new Date().getTime());

            // Update columns
            $("#ColumnsPlaceholder").load(url, function () {
                AGA.Helper.unblockElement("#ColumnsBody");
            });
        }
    };

    var updateCurrent = function () {
        var current = getCurrentQueryId();

        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetIsReadOnly?queryId=" + String(current) + "&_=" + new Date().getTime());
        var data = {
            queryId: current
        };

        $.ajax({
            url: url,
            method: "POST",
            data: data,
            success: function (data) {
                isReadOnly = (data.isReadOnly == "S") || ($("#MustBeReadOnly").length > 0);
                updateFilters(current);
                updateColumns(current);
                $(".dynamic-query-output").empty()
                $(".row-message-execute").show();
            },
        });
    };

    var selectQueryImplementation = function (queryId, queryName) {
        AGA.Lookup.setValue("DynamicQuerySelectorMain", queryId, queryName);
    };

    var getFilterData = function () {
        var queryId = getCurrentQueryId();
        if (AGA.Helper.isNullValue(queryId))
            return null;

        var valores = AGA.Form.getValues("FormFiltros");
        var names = [];
        var values = [];
        for (var prop in valores) {
            if (valores.hasOwnProperty(prop)) {
                names.push(prop);
                values.push(valores[prop]);
            }
        }

        return {
            queryId: queryId,
            names: names,
            values: values
        };
    };

    var saveFilterData = function (data) {
        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveUserFilterValues");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var saveFilterValues = function () {
        var data = getFilterData();
        saveFilterData(data);
    };

    var queryChangedImplementation = function () {
        // Limpar o timeout para garantir que o filtro antigo seja salvo
        saveTimeout = null;

        updateCurrent();
    };

    var createNewImplementation = function (e) {
        var url = $(".aga-dynamic-query-selector").data("urlCreateNew");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            Benner.Widget.disposeModal);
    };

    var manageImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlManaging");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };

    var copyImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlCopy");
        var currentQueryId = getCurrentQueryId();
        url = url + "&queryId=" + String(currentQueryId);
        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };

    var changeFiltersImplementation = function () {

        // Salvar filtros
        clearSaveTimeout();
        saveFilterValues();

        // Abrir modal
        var url = $(".aga-dynamic-query-selector").data("urlManageFilters");
        url += "?imp=1&queryId=" + String(getCurrentQueryId());

        var modalConfig = getModalConfiguration({
            url: url,
            displayTitle: true,
            title: "Filtros da consulta"
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            function () {
                Benner.Widget.disposeModal();
                updateFilters(getCurrentQueryId());
            }
        );
    };

    var clearFilterValuesImplementation = function () {
        clearSaveTimeout();
        $("#FiltrosBody").find(".aga-lookup").each(function (index, item) { AGA.Lookup.clear(item); });
        $("#FiltrosBody").find(".aga-date").each(function (index, item) { AGA.Date.clear(item); });
        $("#FiltrosBody").find(".aga-number").each(function (index, item) { AGA.Number.setValue(item, ''); });
        $("#FiltrosBody").find(".aga-radio").each(function (index, item) { AGA.Radio.clear(item); });
        $("#FiltrosBody").find(".aga-text").each(function (index, item) { AGA.Text.clear(item); });
        saveFilterValues();
    };

    var sugestEndValue = function (e) {
        if ($(e.currentTarget).hasClass("aga-date") && e.name) {
            var regex = /^([A-Z_0-9]*)_DE$/;
            var matches = regex.exec(e.name);
            if (matches && matches.length > 1) {
                var target = matches[1] + "_ATE";
                var value = e.value;

                AGA.Date.setValue(target, value);
            }
        }
    };

    var anyFilterChangeImplementation = function (e) {
        sugestEndValue(e);
        clearSaveTimeout();
        var data = getFilterData();
        saveTimeout = setTimeout(function () {
            saveTimeout = null;
            saveFilterData(data);
        }, 2000);

        $(".dynamic-query-output").empty()
        $(".row-message-execute").show();
    };

    var internalSaveColumns = function (names) {
        var data = {
            queryId: getCurrentQueryId(),
            names: names
        };

        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveSelectedColumns");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var saveColumns = function () {
        var names = [];

        $(".dynamic-query-columns-selected .col-item-selected").each(function (index, item) {
            var name = $(item).data("name");
            if (name)
                names.push(name);
        });

        $(".dynamic-query-facts input.dynamic-query-fact:checked").each(function (index, item) {
            var name = $(item).data("name");
            if (name)
                names.push(name);
        });
        internalSaveColumns(names);
    };

    var handleSelectedItemMoveUp = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var prev = $(liSource).prev();
        if (prev && !$(prev).hasClass("item-selected-pattern")) {
            $(liSource).insertBefore(prev);
        }
        saveColumns();
    };

    var handleSelectedItemMoveDown = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var next = $(liSource).next();
        if (next) {
            $(liSource).insertAfter(next);
        }
        saveColumns();
    };

    var handleItemUnselect = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var dataName = $(liSource).data("name");
        $(liSource).detach();

        $(".dynamic-query-columns > [data-name=" + dataName + "]").removeClass("column-is-selected");
        saveColumns();
    };

    var handleItemSelect = function (e) {
        var liSource = $(e.currentTarget).closest("li");

        // Remover item
        $(liSource).addClass("column-is-selected");

        // Adicionar lista selecionados  
        var pattern = $(".item-selected-pattern").get(0);
        var item = pattern.cloneNode(true);

        $(item)
            .data("name", liSource.data("name"))
            .removeClass("hide item-selected-pattern")
            .append(liSource.data("fullDisplay"));

        $(".dynamic-query-columns-selected").append(item);
        saveColumns();
    };

    var handleSearchBar = function () {
        var texto = $(".dynamic-query-search").val();

        var itens = $(".col-item-selectable");

        if (texto.length > 0) {
            var exp = new RegExp(texto, 'i');
            for (var i = 0; i < itens.length; i++) {
                var coluna = itens[i];

                var nomeCampo = coluna.dataset.fullDisplay;

                if (!exp.test(nomeCampo)) {
                    coluna.classList.add('hidden');
                } else {
                    coluna.classList.remove('hidden');
                }
            }
        } else {
            for (var i = 0; i < itens.length; i++) {
                var coluna = itens[i];
                coluna.classList.remove('hidden');
            }
        }
    };

    var handleDynamicQueryFact = function () {
        saveColumns();
    };

    var handlePortletClick = function (e) {
        $(e.currentTarget).closest(".portlet-title").find(".tools > a.collapse, .tools > a.expand").click();
    };

    var generateImplementation = function (format) {

        if (isCustomQuery) {
            AGA.DynamicQuery.Custom.willGenerate(format);
        }

        var data = getFilterData();
        data.format = format;
        if (!isCustomQuery) {
            data.breaks = document.getElementById("QuantidadeQuebras").value;
            if (data.breaks === "") {
                data.breaks = 0;
            }
        } else {
            data.breaks = $("input[name=TEMQUEBRA]:checked").length;
        }
        var url = AGA.Ajax.getUrlPath("DynamicQuery/Generate");
        AGA.Helper.blockUI();
        $(".row-message-execute").hide();
        $(".dynamic-query-output").empty()

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch {
            AGA.Helper.unblockUI();
        }
    };

    var navigateGridImplementation = function (index, count) {
        var data = getFilterData();
        data.StartIndex = index;
        data.Count = count;

        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetGrid");
        AGA.Helper.blockUI();

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").html(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch {
            AGA.Helper.unblockUI();
        }
    };

    var inited = false;
    var initImplementation = function () {
        if (inited) return;
        inited = true;

        isCustomQuery = $(".aga-dynamic-query-selector").data("query-type") == "69";
        isReadOnly = $("#MustBeReadOnly").length > 0;

        if (!isCustomQuery) {
            $("body").on("click", ".dynamic-query-moveup", handleSelectedItemMoveUp);
            $("body").on("click", ".dynamic-query-movedown", handleSelectedItemMoveDown);
            $("body").on("click", ".dynamic-query-unselect", handleItemUnselect);
            $("body").on("click", ".dynamic-query-select", handleItemSelect);
            $("body").on("input", ".dynamic-query-search", handleSearchBar);
            $("body").on("click", ".dynamic-query-fact", handleDynamicQueryFact);
        }
        else {
            AGA.DynamicQuery.Custom.customInit();
        }

        $("body").on("click", ".dynamic-query-portlet > .portlet-title > .caption", handlePortletClick);
    };

    var _events = [];
    var addEventListenerImplementation = function (eventName, callback) {
        _events.push({ eventName: eventName, callback: callback });
    };

    var dispatchEventImplementation = function (eventName, data) {
        for (var i = 0; i < _events.length; i++) {
            if (_events[i].eventName === eventName) {
                _events[i].callback(data);
            }
        }
    };

    var customModule = (function () {

        var movingRow;
        var movingGrid;

        var filterModes = { none: "none", editing: "editing", "running": "running" };

        var filterMode = filterModes.none;

        var selectedInModal = [];

        var aggregationOptions = [
            { value: 0, text: "Nenhum" },
            { value: 1, text: "Soma" },
            { value: 2, text: "Contagem" },
            { value: 3, text: "Contagem Distinta" },
            { value: 4, text: "Média" },
            { value: 5, text: "Mínimo" },
            { value: 6, text: "Máximo" }
        ];

        var formatOptions = [
            { value: 0, text: "Padrão" },
            { value: 1, text: "Inteiro" },
            { value: 2, text: "Moeda" },
            { value: 3, text: "4 casas decimais" },
            { value: 4, text: "Ano" },
            { value: 5, text: "Mês/Ano" },
            { value: 6, text: "Dia/Mês/Ano" },
            { value: 7, text: "Dia/Mês/Ano Hora/Minuto" },
            { value: 8, text: "Hora/Minuto" },
            { value: 9, text: "Horas a partir de minutos" },
            { value: 10, text: "Horas a partir de horas" }
        ];

        var buttonIds = {
            adicionarColunas: "#BtnAdicionarColunas",
            salvarColunas: "#BtnSalvarColunas",
            alterarFiltros: "#BtnAlterarFiltros",

        };

        var existeNome = function (name) {
            var existe = false;
            $("#CustomColumnsGrid").find("input[name=NOME]").each(function (index, item) {
                var colName = $(item).val();
                if (colName == name) {
                    existe = true;
                }
            });
            return existe;
        };

        var getNewName = function (path) {
            var parts1 = path.split('>');
            var name = parts1.pop().replace('.', '_');
            var root = name;
            var count = 1;
            while (existeNome(name)) {
                name = root + count;
                count++;
            }

            return name;
        };

        var getEditingFilterHtml = function (item) {
            var html = "";
            html += '<tr data-filter-name="' + item.Name + '" data-path="' + item.Path + '" ">';
            html += '<td><div draggable="true" ondragstart="AGA.DynamicQuery.Custom.dragRowStart(event)" ondragover="AGA.DynamicQuery.Custom.dragRowOver(event)" ondrop="AGA.DynamicQuery.Custom.dragRowDrop(event)"><i class="fa fa-up-down"></i></div></td>';
            html += '<td><input type="text" class="form-control custom-field" name="FILTER_PATH" value="' + item.Path + '" title="' + item.Path + '" readonly="readonly" /></td>';
            html += '<td><input type="text" class="form-control custom-field" name="FILTER_TITULO" value="' + item.Title + '" /></td>';
            html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" class="custom-field" name="FILTER_OBRIGATORIO" ' + (item.Required === "S" ? 'checked="checked"' : '') + '"><span></span></label></td>';
            html += '<td><a title="Excluir filtro" class="btn btn-xs btn-circle red" onclick="AGA.DynamicQuery.Custom.deleteCustomFilter(this);" href="javascript:;"><i aria-hidden="true" class="fa-duotone fa-trash-can fa-fw"></i></a></td>';
            html += '</tr>';
            return html;
        }

        var loadEditingCustomFilters = function (data) {
            var html = "";
            data.forEach(function (item) {
                html += getEditingFilterHtml(item);
            });

            $("#CustomFiltersGrid > tbody").html(html);
        };

        var setFilterMode = function (filterMode) {

            var queryId = getCurrentQueryId();

            if (filterMode == filterModes.editing) {

                $(".btn-generation").each(function (index, item) {
                    AGA.JavascriptButton.disable(item);
                });

                var data = {
                    queryId: queryId
                };

                AGA.Helper.blockElement("#FormFiltros", "Carregando filtros...");
                var url = AGA.Ajax.getUrlPath("DynamicQuery/GetCustomFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());
                $.ajax({
                    url: url,
                    method: "POST",
                    data: data,
                    success: function (data) {
                        AGA.Helper.unblockElement("#FormFiltros");

                        $("#FiltrosPlaceholder").hide();
                        $("#LimparFiltrosButton").hide();
                        $(buttonIds.alterarFiltros).hide();

                        loadEditingCustomFilters(data.filters);

                        $("#EdicaoFiltrosPlaceholder").show();
                        $("#AdicionarFiltrosButton").show();
                        $("#SalvarFiltrosButton").show();
                        $("#CancelarFiltrosButton").show();
                    },
                });

            } else if (filterMode == filterModes.running) {
                AGA.Helper.blockElement("#FormFiltros", "Carregando filtros...");
                var url = AGA.Ajax.getUrlPath("DynamicQuery/GetFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());

                // Update filtros
                $("#FiltrosPlaceholder").load(url, function () {
                    AGA.Helper.unblockElement("#FormFiltros");

                    $("#EdicaoFiltrosPlaceholder").hide();
                    $("#SalvarFiltrosButton").hide();
                    $("#CancelarFiltrosButton").hide();
                    $("#AdicionarFiltrosButton").hide();

                    $("#FiltrosPlaceholder").show();
                    $("#LimparFiltrosButton").show();
                    $(buttonIds.alterarFiltros).show();
                    AGA.JavascriptButton.enable("LimparFiltrosButton");
                    AGA.JavascriptButton.setEnabled(buttonIds.alterarFiltros, !isReadOnly);

                    $(".btn-generation").each(function (index, item) {
                        AGA.JavascriptButton.enable(item);
                    });
                });

            } else {
                $("#EdicaoFiltrosPlaceholder").hide();
                $("#SalvarFiltrosButton").hide();
                $("#CancelarFiltrosButton").hide();
                $("#AdicionarFiltrosButton").hide();

                $("#FiltrosPlaceholder").hide();
                $("#LimparFiltrosButton").show();
                $(buttonIds.alterarFiltros).show();
                AGA.JavascriptButton.disable("LimparFiltrosButton");
                AGA.JavascriptButton.disable(buttonIds.alterarFiltros);
            }
        };

        var getNewFilterName = function (newHash) {
            var name = "FILTRO";
            var n = $("#CustomFiltersGrid tr").length;
            var candidate = name + n;
            while ($("#CustomFiltersGrid tr[data-filter-name=" + candidate + "]").length > 0 || newHash.hasOwnProperty(candidate)) {
                n++;
                candidate = name + n;
            }
            return candidate;
        };

        var dragRowStart = function (e) {
            movingRow = e.target;
            movingGrid = $(movingRow).closest("table").get(0);
            e.dataTransfer.effectAllowed = 'move';
        };

        var dragRowOver = function (e) {
            // Movendo para própria linha
            if ($(e.target).closest("div").get(0) === movingRow)
                return;

            // Movendo para outro grid
            if ($(e.target).closest("table").get(0) !== movingGrid) {
                return;
            }

            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
        };

        var dragRowDrop = function (e) {

            e.preventDefault();

            var toRow = $(e.target).closest("tr").get(0);
            if (toRow.length === 0)
                return;

            var fromRow = $(movingRow).closest("tr").get(0);

            var children = $(fromRow).parent().find("tr").toArray();
            if (children.indexOf(toRow) > children.indexOf(fromRow))
                $(fromRow).insertAfter(toRow);
            else
                $(fromRow).insertBefore(toRow);

            if (movingGrid.id == "CustomColumnsGrid") {
                setSaveColumsEnabled(true);
                customBreaksSort();
            }
        };

        var openSelectionModal = function (closeCallback) {

            var onOpen = function () {
                AGA.DynamicQuery.Custom.startExplorer();
            };

            var onClose = function () {

                if (selectedInModal.length == 0) {
                    return;
                };

                closeCallback();
            };

            // garantir que não ficou nenhum lixo
            $(".filter-search-form").detach();

            var html = '<div class="filter-search-form note note-info note-bordered" style="margin-bottom: 10px">'
                + '<div class="input-group filter-simple-search col-lg-12 col-md-12 col-sm-12 col-xs-12">'
                + '<input class="dynamic-query-search form-control" /></div></div >'
                + '<div class="dynamic-query-explorer" data-queryid="' + getCurrentQueryId() + '">Carregando...</div>';

            Benner.ModalPage.show({ customBody: html, size: "large", title: "Selecione os campos desejados", height: 500 }, onOpen, onClose);

        };

        var filterSearchFields = function (force) {
            var texto = $(".dynamic-query-search").val();

            // Não quer forçar e não tem filtro
            if (!force && texto.length == 0) {
                return;
            }

            var itens = $("li.col-item-selectable");

            if (texto.length === 0) {
                $(itens).removeClass('hidden');
                return;
            }

            var hashVisiveis = {};

            var exp = new RegExp(texto, 'i');
            $(itens).each(function (index, item) {
                var title = $(item).data("title");
                if (exp.test(title)) {
                    var path = $(item).data("path");
                    hashVisiveis[path] = true;

                    // Deixar parents visiveis
                    $(item).parentsUntil(".dynamic-query-explorer", "li.col-item-selectable").each(function (index2, item2) {
                        var path2 = $(item2).data("path");
                        hashVisiveis[path2] = true;
                    });
                };
            });

            $(itens).each(function (index, item) {
                var path = $(item).data("path");
                if (hashVisiveis[path]) {
                    $(item).removeClass('hidden');
                } else {
                    $(item).addClass('hidden');
                }
            });
        };


        var addExplorerColumns = function (parent, pathPrefix, titlePrefix, columns, ulClass) {

            var html = '<ul class="list-unstyled ' + ulClass + '">';
            columns.forEach(function (item) {
                var path = pathPrefix + item.name;

                html += '<li class="col-item-selectable" data-path="' + path + '" data-title="' + item.title + '" data-display-format="' + item.displayFormat + '">';
                html += '<label class="mt-checkbox mt-checkbox-outline"><input type="checkbox" ';
                html += ' onclick="parent.AGA.DynamicQuery.Custom.toggleExplorerSelection(' + "'" + path + "', '" + titlePrefix + item.title + "'" + ')"><span></span>' + item.title + ' - ' + item.name;

                if (item.targetTable) {
                    html += '<a title="Navegar" data-targettable="' + item.targetTable + '" class="btn btn-xs btn-circle" onclick="AGA.DynamicQuery.Custom.exploreTable(this);" href="javascript:;"><i aria-hidden="true" class="fa-duotone fa-plus fa-fw"></i></a>';
                };

                html += '</label></li>';
            });
            html += '</ul>';

            $(parent).append(html);
        }

        var startExplorerImplementation = function () {
            selectedInModal = [];
            $(".dynamic-query-search").on("input", function () {
                filterSearchFields(true);
            });

            $(".dynamic-query-explorer").each(function (index, item) {
                var queryId = $(item).data("queryid");

                var data = {
                    queryId: queryId,
                    tableName: ""
                };

                var url = AGA.Ajax.getUrlPath("DynamicQuery/GetCustomSelectableFields");
                $.ajax({
                    url: url,
                    method: "POST",
                    data: data,
                    success: function (data) {
                        $(item).empty();
                        addExplorerColumns(item, "", "", data, "");
                    },
                });

            });

            $(".dynamic-query-search").focus();
        };

        var toggleExplorerSelectionImplementation = function (path, title) {
            var wasSelected = false;
            selectedInModal = selectedInModal.filter(function (item) {
                wasSelected = item.path == path;
                return item.path != path;
            });
            if (!wasSelected) {
                selectedInModal.push({ path: path, title: title });
            }
        };

        var exploreTableImplementation = function (element) {

            var a = $(element).closest("a");
            $(a).find("i").toggleClass("fa-plus fa-minus");

            var li = $(element).closest("li");
            if ($(li).is(".loaded")) {

                // reexibir se foi filtrado
                if ($(li).hasClass("hidden")) {
                    $(li).find("li").removeClass("hidden");
                };

                $(li).find("ul").toggle("collapse");
                return;
            }

            var queryId = $(element).closest(".dynamic-query-explorer").data("queryid");
            var tableName = $(a).data("targettable");
            var data = {
                queryId: queryId,
                tableName: tableName
            };

            var url = AGA.Ajax.getUrlPath("DynamicQuery/GetCustomSelectableFields");
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    var parentLi = $(element).closest('li');
                    $(parentLi).addClass("loaded");

                    var path = $(parentLi).data("path") + '>' + tableName + '.';
                    var title = $(parentLi).data("title") + ' - ';

                    addExplorerColumns(li, path, title, data, "collapse");
                    $(parentLi).find("ul").toggle("collapse");
                },
            });
        };

        var deleteCustomColumnImplementation = function (element) {
            var callback = function () {
                $(element).closest('tr').remove();
                customFieldsChanged();
            };
            AGA.Helper.requestConfirmation("Excluir coluna", "Deseja realmente excluir esta coluna?", callback);
        };

        var saveCustomColumnsImplementation = function () {
            var cols = [];
            $("#CustomColumnsGrid > tbody > tr").each(function (index, tr) {
                var item = getCustomColumnFromTr(tr);
                cols.push(item);
            });

            var data = {
                queryId: getCurrentQueryId(),
                columns: cols
            };

            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveCustomSelectedColumns");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });

            setSaveColumsEnabled(false);
        };

        var getHtmlCustomColumn = function (col) {
            var html = "";

            if (isReadOnly) {
                html += '<tr>';
                html += '<td><div></div></td>';
                html += '<td><input type="text" readonly="readonly" class="form-control custom-field" name="NOME" value="' + col.Name + '" title="' + col.Path + '" /></td>';
                html += '<td><input type="text" readonly="readonly" class="form-control custom-field" name="LEGENDA" value="' + col.Title + '" /></td>';
                // create selection for type
                html += '<td><select disabled="disabled" readonly="readonly" class="form-control custom-field" name="FUNCAO">';
                aggregationOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.Aggregation == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><select readonly="readonly" disabled="disabled" class="form-control custom-field disabled" name="SUMARIO">';
                aggregationOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.Summary == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><select readonly="readonly" disabled="disabled" class="form-control custom-field" name="FORMATO">';
                formatOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.DisplayFormat == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" readonly="readonly" disabled class="custom-field break-checkbox-field" name="TEMQUEBRA" ' + (col.HasBreak === "S" ? 'checked="checked"' : '') + '"><span></span></label></td>';
                html += '<td><a title="Excluir coluna" class="btn btn-xs btn-circle red disabled" onclick="" href="javascript:;"><i aria-hidden="true" class="fa-duotone fa-trash-can fa-fw"></i></a></td>';
                html += '</tr>';
            } else {
                html += '<tr data-path="' + col.Path + '" ">';
                html += '<td><div draggable="true" ondragstart="AGA.DynamicQuery.Custom.dragRowStart(event)" ondragover="AGA.DynamicQuery.Custom.dragRowOver(event)" ondrop="AGA.DynamicQuery.Custom.dragRowDrop(event)"><i class="fa fa-up-down"></i></div></td>';
                html += '<td><input type="text" class="form-control custom-field" name="NOME" value="' + col.Name + '" title="' + col.Path + '" /></td>';
                html += '<td><input type="text" class="form-control custom-field" name="LEGENDA" value="' + col.Title + '" /></td>';
                // create selection for type
                html += '<td><select class="form-control custom-field" name="FUNCAO">';
                aggregationOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.Aggregation == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><select class="form-control custom-field" name="SUMARIO">';
                aggregationOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.Summary == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><select class="form-control custom-field" name="FORMATO">';
                formatOptions.forEach(function (option) {
                    html += '<option value="' + option.value + '" ' + (col.DisplayFormat == option.value ? 'selected' : '') + '>' + option.text + '</option>';
                });
                html += '</select></td>';

                html += '<td><label class="boolean-control mt-checkbox mt-checkbox-outline"><input type="checkbox" class="custom-field break-checkbox-field" name="TEMQUEBRA" ' + (col.HasBreak === "S" ? 'checked="checked"' : '') + '"><span></span></label></td>';
                html += '<td><a title="Excluir coluna" class="btn btn-xs btn-circle red" onclick="AGA.DynamicQuery.Custom.deleteCustomColumn(this);" href="javascript:;"><i aria-hidden="true" class="fa-duotone fa-trash-can fa-fw"></i></a></td>';

                html += '</tr>';
            }

            return html;
        };

        var getCustomColumnFromTr = function (tr) {
            var path = $(tr).data("path");
            var name = $(tr).find("input[name=NOME]").val();
            var title = $(tr).find("input[name=LEGENDA]").val();
            var aggregation = $(tr).find("select[name=FUNCAO]").val();
            var summary = $(tr).find("select[name=SUMARIO]").val();
            var displayFormat = $(tr).find("select[name=FORMATO]").val();
            var hasFilter = $(tr).find("input[name=TEMFILTRO]").is(":checked") ? "S" : "N";
            var hasBreak = $(tr).find("input[name=TEMQUEBRA]").is(":checked") ? "S" : "N";
            return {
                Path: path,
                Name: name,
                Title: title,
                Aggregation: aggregation,
                Summary: summary,
                HasFilter: hasFilter,
                HasBreak: hasBreak,
                DisplayFormat: displayFormat
            };
        };

        var setSaveColumsEnabled = function (enabled) {
            AGA.JavascriptButton.setEnabled(buttonIds.salvarColunas, enabled);
        };

        var checkColumnState = function (anyElement) {
            if (!anyElement) {
                return;
            }

            if (isReadOnly) {
                return;
            }

            var tr = $(anyElement).closest("tr");
            var column = getCustomColumnFromTr(tr);

            // Se tiver aggregation não pode ter quebra
            if (column.Aggregation != 0) {
                $(tr).find("input[name=TEMQUEBRA]").prop("checked", false);
                $(tr).find("input[name=TEMQUEBRA]").prop("disabled", true);
            } else {
                $(tr).find("input[name=TEMQUEBRA]").prop("disabled", false);
            }

            if (!$(anyElement).is("input[type=text]")) {
                customBreaksSort();
            }
        };

        var customFieldsChanged = function (e) {
            if (e && e["currentTarget"]) {
                checkColumnState(e.currentTarget);
            }

            setSaveColumsEnabled(true);
        };

        var updateCustomColumnsGrid = function (columns) {
            var html = "";
            columns.forEach(function (col) {
                html += getHtmlCustomColumn(col);
            });

            AGA.JavascriptButton.setEnabled(buttonIds.adicionarColunas, !isReadOnly);
            AGA.JavascriptButton.setEnabled(buttonIds.salvarColunas, false);

            if (isReadOnly) {                
                $(buttonIds.salvarColunas).hide();
            }

            $("#CustomColumnsGrid > tbody").html(html);
            $("#CustomColumnsGrid > tbody > tr").each(function (index, tr) { checkColumnState(tr); });
            $("#ColumnsPlaceholder").show();
        };

        var updateCustomColumns = function (queryId) {

            AGA.Helper.blockElement("#CustomColumnsBody", "Carregando colunas...");
            var url = AGA.Ajax.getUrlPath("DynamicQuery/GetCustomSelectedColumns?queryId=" + String(queryId) + "&_=" + new Date().getTime());

            // Obter colunas do servidor
            $.ajax({
                url: url,
                method: "POST",
                data: { queryId: queryId },
                success: function (data) {
                    updateCustomColumnsGrid(data.columns);
                    AGA.Helper.unblockElement("#CustomColumnsBody");
                },
                fail: function (data) {
                    AGA.Helper.unblockElement("#CustomColumnsBody");
                }
            });
        };

        var updateCustomFilters = function () {
            setFilterMode(filterModes.running)
        };

        var editFiltersClick = function () {
            setFilterMode(filterModes.editing);
        };

        var saveFiltersClick = function () {
            var queryId = getCurrentQueryId();
            var filtros = $("#CustomFiltersGrid > tbody > tr")
                .map(function () {
                    var item = {
                        Name: $(this).data("filterName"),
                        Path: $(this).data("path"),
                        Title: $(this).find("input[name=FILTER_TITULO]").val(),
                        Required: $(this).find("input[name=FILTER_OBRIGATORIO]").is(":checked") ? "S" : "N"
                    };
                    return item;
                })
                .get();

            var data = {
                queryId: queryId,
                filters: filtros
            };

            AGA.Helper.blockElement("#FormFiltros", "Salvando filtros...");
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveCustomFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockElement("#FormFiltros");
                    setFilterMode(filterModes.running);
                },
            });
        };

        var cancelFiltersClick = function () {
            setFilterMode(filterModes.running);
        };

        var addFiltersClick = function () {
            var onClose = function () {
                var existentes = $("#CustomFiltersGrid > tbody > tr")
                    .toArray()
                    .reduce(
                        function (prev, curr) {
                            var path = $(curr).data("path");
                            prev[path] = true;
                            return prev;
                        }, {});

                var html = "";
                var newHash = {};
                selectedInModal.forEach(function (item) {
                    // Verifica se o item já existe
                    if (!existentes.hasOwnProperty(item.path)) {
                        var item = {
                            Name: getNewFilterName(newHash),
                            Path: item.path,
                            Title: item.title,
                            Required: "N",
                        };

                        newHash[item.Name] = true;
                        html += getEditingFilterHtml(item);
                    }
                });

                if (html !== "") {
                    $("#CustomFiltersGrid > tbody").append(html);
                };
            };

            openSelectionModal(onClose);

        };

        var deleteCustomFilterImplementation = function (element) {
            var callback = function () {
                $(element).closest('tr').remove();
            };
            AGA.Helper.requestConfirmation("Excluir filtro", "Deseja realmente excluir filtro?", callback);
        };

        var addCustomColumnImplementation = function (element) {

            var onClose = function () {

                var html = "";

                var existentes = $("#CustomColumnsGrid > tbody > tr").toArray().map(function (item) {
                    return $(item).data("path");
                });

                selectedInModal.forEach(function (item) {
                    var col = {
                        Path: item.path,
                        Name: getNewName(item.path),
                        Title: item.title,
                        Aggregation: 0,
                        Summary: 0,
                        HasFilter: "N",
                        HasBreak: "N",
                        DisplayFormat: 0
                    };

                    html += getHtmlCustomColumn(col);
                });

                if (html !== "") {
                    $("#CustomColumnsGrid > tbody").append(html);
                    setSaveColumsEnabled(true);
                };
            };

            openSelectionModal(onClose);
        };

        var customBreaksSort = function (e) {

            if (e && e["currentTarget"]) {
                $(e.currentTarget).closest("tr").addClass("blink");
                setTimeout(function () {
                    $(e.currentTarget).closest("tr").removeClass("blink");
                }, 1000);
            }

            var $rows = $('#CustomColumnsGrid > tbody > tr');

            $rows.sort(function (a, b) {
                var ak = $(a).find(".break-checkbox-field").is(":checked") ? -1 : 1;
                var bk = $(b).find(".break-checkbox-field").is(":checked") ? -1 : 1;
                return ak - bk;
            });

            $("#CustomColumnsGrid > tbody").append($rows);
        };

        var customInitImplementation = function () {
            setFilterMode(filterModes.none);
            $("body").on('input', '.custom-field', customFieldsChanged);
            $("body").on('change', '.break-checkbox-field', customBreaksSort);
        };

        var willGenerateImplementation = function (format) {
            if (AGA.JavascriptButton.isEnabled(buttonIds.salvarColunas) && !isReadOnly) {
                saveCustomColumnsImplementation();
            }
        };

        return {
            customInit: customInitImplementation,
            dragRowStart: dragRowStart,
            dragRowOver: dragRowOver,
            dragRowDrop: dragRowDrop,
            updateCustomColumns: updateCustomColumns,
            updateCustomFilters: updateCustomFilters,
            editFiltersClick: editFiltersClick,
            saveFiltersClick: saveFiltersClick,
            cancelFiltersClick: cancelFiltersClick,
            addFiltersClick: addFiltersClick,
            deleteCustomFilter: deleteCustomFilterImplementation,
            addCustomColumn: addCustomColumnImplementation,
            deleteCustomColumn: deleteCustomColumnImplementation,

            startExplorer: startExplorerImplementation,
            exploreTable: exploreTableImplementation,
            toggleExplorerSelection: toggleExplorerSelectionImplementation,

            saveCustomColumns: saveCustomColumnsImplementation,
            willGenerate: willGenerateImplementation,
        };
    })();

    return {
        init: initImplementation,
        selectQuery: selectQueryImplementation,
        queryChanged: queryChangedImplementation,
        createNew: createNewImplementation,
        manage: manageImplementation,
        copy: copyImplementation,
        changeFilters: changeFiltersImplementation,
        clearFilterValues: clearFilterValuesImplementation,
        anyFilterChange: anyFilterChangeImplementation,
        generate: generateImplementation,
        navigateGrid: navigateGridImplementation,
        addEventListener: addEventListenerImplementation,
        dispatchEvent: dispatchEventImplementation,

        Custom: customModule,
    };
})();

$(document).ready(function () {
    AGA.DynamicQuery.init();
});